import React from 'react';
import styled from 'styled-components';

import { FreeCodeBlockData } from 'api/cms';
import { RichText } from 'components/Text';
import emailSignupBlock from 'utils/styles/emailSignupBlock';

const StyledRichText = styled(RichText)`
  ${emailSignupBlock}
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const FreeCodeBlock = ({ data: { code } }: { data: FreeCodeBlockData }) => (
  <StyledRichText
    dangerouslySetInnerHTML={{
      __html: code,
    }}
    tag="section"
  />
);

export default FreeCodeBlock;
